// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1VwMD","colCheckbox":"styles_colCheckbox__2s0C-"};